export default __webpack_public_path__ + "static/media/agustin12.77c547f7.png";